import { IsolatedModal } from '@components/shared/modals/IsolatedModal';
import { ajaxCatch } from '@helper/api';
import { DateFormat } from '@helper/formatHelpers';
import { DictionariesConstants } from '@services/DictionariesConstants';
import { Button, Col, notification, Select } from 'antd';
import { Field, Formik, FormikActions, FormikProps } from 'formik';
import { FDatePicker, FFieldLabel, FSelect, FSelectDictionary } from 'forms/FormikFormItems';
import { CenteredRow } from 'layout/CenteredRow';
import React, { useState } from 'react';
import { CreateAutomaticNoteSchema } from './validation/CreateAutomaticNoteSchema';
import { useRootData } from '@hooks/hook';
import { IDictionaryStore } from 'stores/DictionaryStore';
import { getEssityApiClient } from '@services/EssityApi';
import { IGridStore } from 'stores/GridStore';
import { CreatePharmacyTaxCreditNotesCommand } from '@services/src/models';

interface IProps {
}

export const CreateAutomaticNoteModal = (props: IProps) => {
	const [visible, setVisible] = useState<boolean>();
	const dictionaryStore: IDictionaryStore = useRootData(
		(store) => store.dictionaryStore
	);
	const gridStore: IGridStore = useRootData((store) => store.gridStore);

	const handleCancel = () => {
		setVisible(false);
	};
	const handleCreate = (
		values: any,
		actions: FormikActions<any>
	) => {


		ajaxCatch(
			() =>
				getEssityApiClient().then((api) =>
					api.pharmacyTaxNote.createBulkCreditNotes({
						body: {
							month: values.month.month() + 1,
							year: values.year.year(),
							voivodeshipId: values.voivodeshipId
						} as CreatePharmacyTaxCreditNotesCommand,
					})
				).finally(() => actions.setSubmitting(false)),
			(response) => {
				gridStore.searching.set(true);
				actions.resetForm();
				setVisible(false);
				notification.success({
					placement: 'bottomRight',
					message:
						`Successfully requested generation of credit notes. Create: ${response.toCreateNotesCount}, update: ${response.toUpdateNotesCount}`,
				});
			},

		);
	};
	const handleRender = (
		props: FormikProps<any>
	) => {
		return (
			visible && (
				<IsolatedModal
					title="Create credit notes"
					visible={visible}
					width="15vw"
					centered
					cancelButtonProps={{ hidden: true }}
					okButtonProps={{ hidden: true }}
					maskClosable={false}
					onCancel={handleCancel}
					closable={true}
					destroyOnClose
				>
					<>
						<CenteredRow>
							<Col span={22}>
								{/* <div className="fieldbox"> */}
								<FFieldLabel label="Voivodeship" />
								<Field
									component={FSelectDictionary}
									placeholder="Voivodeships"
									name="voivodeshipId"
									readOnly={false}
									children={dictionaryStore?.getDictionary(
										DictionariesConstants.Voivodeships
									)?.values?.map(
										(x, i) => (
											x.id && <Select.Option key={i} value={x.id}>
												{x.value}
											</Select.Option>
										)
									)}
								/>

							</Col>


						</CenteredRow>
						<CenteredRow>
							<Col span={11} >
								<FFieldLabel label="Year" />
								<Field
									component={FDatePicker}
									placeholder="Year"
									style={{ width: '100%' }}
									name="year"
									picker="year"
									format={DateFormat.Year}
								/>
							</Col>
							<Col span={11} style={{ paddingLeft: 5 }}>
								<FFieldLabel label="Month" />
								<Field
									component={FDatePicker}
									placeholder="Month"
									name="month"
									style={{ width: '100%' }}
									picker="month"
									format={DateFormat.Month}
								/>
							</Col>
						</CenteredRow>

						<CenteredRow style={{ marginTop: '15px' }}>
							<Button
								type="primary"
								size="large"
								shape="round"
								onClick={() => {
									if (!props.isSubmitting) {
										props.submitForm();
									}
								}}
							>
								Create credit notes
							</Button>
						</CenteredRow>
					</>
				</IsolatedModal>
			)

		);
	};
	return (
		<>
			<Button
				size="large"
				shape="round"
				type="primary"
				onClick={() => {
					setVisible(true);
				}}
			>
				Create credit notes
			</Button>
			<Formik
				validateOnChange
				validateOnBlur
				validationSchema={CreateAutomaticNoteSchema}
				enableReinitialize
				isInitialValid={false}
				initialValues={{}}
				onSubmit={(
					values,
					actions: FormikActions<any>
				) => handleCreate(values, actions)}
				render={handleRender}
			/>
		</>
	);
};
